import Vue, { computed } from 'vue'

import i18n from '@/i18n/SetupI18n'
import gitVersion from '@/gitVersion.js'

/**
 * A composable function to get the app info string to display as a tooltip in the logo.
 * @returns {string} The app info string.
 */
export function useAppInfo() {
  const { environmentName } = Vue.prototype.$appConfiguration

  const appInfo = computed(() => {
    return `${i18n.t('app-info.name-short')} - ${environmentName} - ${i18n.t('app-info.version')} ${gitVersion}`
  })

  return appInfo
}
